import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import FormHelper from '../../../../../../../helpers/FormHelper';
import FileList from '../../../../../../../components/fileList/index.';
import { Descriptions } from 'antd';

const ImagesSection = ({ singleItem, updateInProcess, handleDeleteFile }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6} />
      <Col span={9}>
        <Form.Item label={t('Location')} name='location'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
        <Form.Item label={t('File')}>
          <Form.Item
            name='file'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLSX', 'PPTX'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLSX PPTX
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
            </Descriptions>
        </Form.Item>
      </Col>
      <Col span={6}>
        <Row>
          <Col span={24}>
            <FileList
              onDelete={handleDeleteFile}
              loading={updateInProcess}
              data={
                singleItem?.file
                  ? [
                      {
                        file: {
                          url: singleItem?.file,
                          file_name: singleItem?.file_name || 'name',
                          id: singleItem?.file_id || 'id',
                        },
                        image_id: singleItem?.file_id,
                        param: 'file',
                      },
                    ]
                  : []
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default React.memo(ImagesSection);
